import React from "react";

import { Link } from "react-router-dom";

import { Footer } from "../../components/Footer";
import { HeaderWrapper } from "../../components/Header/HeaderWrapper";

// Human-readable sitemap linked from the footer. Only public, browsable
// pages are listed — sign-up steps, admin and per-item detail pages are left out.
const SITEMAP_SECTIONS: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: "Explore",
    links: [
      { label: "Home", to: "/" },
      { label: "Coupons", to: "/coupons-list" },
      { label: "Coupon Map", to: "/coupons-map" },
      { label: "Local Businesses", to: "/businesses-list" },
      { label: "Online Brands", to: "/online-brands-list" },
      { label: "Blog", to: "/blogs" },
    ],
  },
  {
    title: "Your Account",
    links: [
      { label: "Sign In", to: "/customer-login" },
      { label: "Create a Free Account", to: "/customer-signup" },
      { label: "My Account", to: "/my-account" },
      { label: "Favourites", to: "/favourites" },
      { label: "Followed Businesses", to: "/businesses-followed" },
    ],
  },
  {
    title: "For Business",
    links: [
      { label: "Join as a Business", to: "/business" },
      { label: "Launch in Moncton", to: "/launch-moncton" },
      { label: "Launch in Calgary", to: "/launch-calgary" },
      { label: "Launch in Canada", to: "/launch-canada" },
      { label: "Business Resources", to: "/business-resources" },
      { label: "Business Login", to: "/login" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "App Features", to: "/landing" },
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms-of-service/customer" },
    ],
  },
];

const Sitemap: React.FC = () => (
  <div className="relative w-full bg-white overflow-x-hidden min-h-screen">
    <HeaderWrapper />
    <main className="relative z-10 w-full max-w-[1240px] mx-auto px-4 md:px-8 pt-[120px] md:pt-[140px] pb-20">
      <h1 className="text-[34px] md:text-[44px] font-normal text-[#2A2A2A] leading-tight mb-12">
        Site<span className="font-semibold text-[#D90000]">map</span>
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {SITEMAP_SECTIONS.map((section) => (
          <section key={section.title}>
            <h2 className="text-[20px] font-semibold text-[#222] mb-4">{section.title}</h2>
            <ul className="list-none p-0 m-0 space-y-3 text-[16px]">
              {section.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-gray-600 no-underline hover:text-[#D90000] transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </main>
    <Footer />
  </div>
);

export default Sitemap;
